import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getDevicesByKind } from 'utils/deviceUtils';
import classes from './ShareHDMI.module.scss';
import { hooks } from '@lifesize/clients.sdk';
import { useDispatch } from 'react-redux';
import { stopWebcam } from 'actions/media';
import { media } from '@lifesize/clients.sdk';
import lsConfig from 'utils/global-config';
import {
  CZECH_LANGUAGE_CODE,
  DUTCH_LANGUAGE_CODE,
  ENGLISH_LANGUAGE_CODE,
  FINNISH_LANGUAGE_CODE,
  FRENCH_LANGUAGE_CODE,
  GERMAN_LANGUAGE_CODE,
  ITALIAN_LANGUAGE_CODE,
  JAPANESE_LANGUAGE_CODE,
  KOREAN_LANGUAGE_CODE,
  NORWEGIAN_LANGUAGE_CODE,
  POLISH_LANGUAGE_CODE,
  PORTUGUESE_LANGUAGE_CODE,
  RUSSIAN_LANGUAGE_CODE,
  SIMPLIFIED_CHINESE_LANGUAGE_CODE,
  SPANISH_LANGUAGE_CODE,
  SWEDISH_LANGUAGE_CODE,
  TRADITIONAL_CHINESE_LANGUAGE_CODE,
  languageJSONList
} from '../../constants/Gems';
import { getCurrentLanguage } from 'utils/guest-utils';

const ShareHDMI = () => {
  const dispatch = useDispatch();
  const devices = hooks.useDevices();
  const [streamActive, setStreamActive] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(ENGLISH_LANGUAGE_CODE);
  const [languageJSON, setLanugageJSON] = useState(languageJSONList[ENGLISH_LANGUAGE_CODE]);
  const videoInputDevices = useMemo(() => getDevicesByKind(devices, 'videoinput'), [devices]);
  const videoRef = useRef();

  useEffect(() => {
    media.acquireWebcam();
    document.title = 'Lifesize-HDMI';
    let interval = setInterval(async () => {
      if (
        (!!videoRef.current && !!videoRef.current.srcObject && !videoRef.current.srcObject.active) ||
        !videoRef.current
      ) {
        setStreamActive(false);
        if (videoInputDevices.length > 0) {
          initializeMedia();
        }
      }
    }, 3000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [dispatch, videoInputDevices]);

  useEffect(() => {
    const currentLanguage = getCurrentLanguage();
    setPageLanguage(currentLanguage);
  }, []);

  useEffect(() => {
    document.title = 'Lifesize-HDMI';
    if (videoInputDevices.length > 0) {
      initializeMedia();
    }
    // eslint-disable-next-line
  }, [videoInputDevices]);

  useEffect(() => {
    if (!!currentLanguage) {
      setLanugageJSON(languageJSONList[currentLanguage]);
    }
  }, [currentLanguage]);

  useEffect(() => {
    // window.onbeforeunload = null;
    lsConfig.skipOnBeforeUnload();
  }, [currentLanguage]);

  const setPageLanguage = (currentLanguage) => {
    switch (currentLanguage) {
      case ENGLISH_LANGUAGE_CODE:
      case FRENCH_LANGUAGE_CODE:
      case SPANISH_LANGUAGE_CODE:
      case ITALIAN_LANGUAGE_CODE:
      case GERMAN_LANGUAGE_CODE:
      case NORWEGIAN_LANGUAGE_CODE:
      case CZECH_LANGUAGE_CODE:
      case DUTCH_LANGUAGE_CODE:
      case POLISH_LANGUAGE_CODE:
      case PORTUGUESE_LANGUAGE_CODE:
      case FINNISH_LANGUAGE_CODE:
      case SWEDISH_LANGUAGE_CODE:
      case RUSSIAN_LANGUAGE_CODE:
      case KOREAN_LANGUAGE_CODE:
      case JAPANESE_LANGUAGE_CODE:
      case TRADITIONAL_CHINESE_LANGUAGE_CODE:
      case SIMPLIFIED_CHINESE_LANGUAGE_CODE:
        setCurrentLanguage(currentLanguage);
        break;
      default: {
        setCurrentLanguage(ENGLISH_LANGUAGE_CODE);
        break;
      }
    }
  };

  // eslint-disable-next-line
  const initializeMedia = useCallback(() => {
    const HDMIinput = videoInputDevices.find((input) => input.label.includes('HDMI'));
    if (!!HDMIinput) {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: {
              exact: HDMIinput.value
            }
          }
        })
        .then((stream) => {
          // this.player.srcObject = stream;
          setStreamActive(true);
          videoRef.current.srcObject = stream;
          dispatch(stopWebcam());
        })
        .catch((error) => {
          console.error('Stream Connection Error', error);
          setStreamActive(false);
          dispatch(stopWebcam());
        });
    } else {
      // Handle no HDMI input found
      setStreamActive(false);
      dispatch(stopWebcam());
    }
  });

  return (
    <div className={classes.container}>
      {streamActive ? (
        <video width="100%" ref={videoRef} autoPlay />
      ) : (
        <div className={classes.textContainer}>{languageJSON.hdmi_connected}</div>
      )}
    </div>
  );
};

export default ShareHDMI;
